"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.WIKI_URLS = exports.RULEBOOK_URLS = exports.WIKI = void 0;
exports.WIKI = 'https://github.com/terraforming-mars/terraforming-mars/wiki';
exports.RULEBOOK_URLS = {
    base: `${exports.WIKI}/Rulebooks`,
    corpera: `${exports.WIKI}/Rulebooks`,
    venus: `${exports.WIKI}/Rulebooks`,
    prelude: `${exports.WIKI}/Rulebooks`,
    colonies: `${exports.WIKI}/Rulebooks`,
    turmoil: `${exports.WIKI}/Rulebooks`,
    promo: `${exports.WIKI}/Variants#promo-cards`,
    prelude2: `${exports.WIKI}/Rulebooks`,
    ares: `${exports.WIKI}/Ares`,
    community: `${exports.WIKI}/Variants#community`,
    moon: `${exports.WIKI}/The-Moon`,
    pathfinders: `${exports.WIKI}/Pathfinders`,
    ceo: `${exports.WIKI}/CEOs`,
    starwars: `${exports.WIKI}/StarWars`,
    underworld: `${exports.WIKI}/Underworld`,
};
exports.WIKI_URLS = {
    changelog: `${exports.WIKI}/Changelog`,
    aresExtreme: `${exports.WIKI}/Ares-Extreme`,
    alternativeVenusBoard: `${exports.WIKI}/Alternative-Venus-Board`,
    moonStandardProjectVariant: `${exports.WIKI}/Variants#moon-standard-project-variant`,
    escapeVelocity: `${exports.WIKI}/Escape-Velocity`,
    worldGovernmentTerraforming: `${exports.WIKI}/Variants#world-government-terraforming`,
    trSoloMode: `${exports.WIKI}/Variants#tr-solo-mode`,
    allowUndo: `${exports.WIKI}/Variants#allow-undo`,
    merger: `${exports.WIKI}/Variants#Merger`,
    randomizeBoardTiles: `${exports.WIKI}/Variants#randomize-board-tiles`,
    setPredefinedGame: `${exports.WIKI}/Variants#set-predefined-game`,
    removeNegativeGlobalEvents: `${exports.WIKI}/Variants#remove-negative-global-events`,
    initialDraft: `${exports.WIKI}/Variants#initial-draft`,
    randomMilestonesAndAwards: `${exports.WIKI}/Variants#random-milestones-and-awards`,
    venusTerraforming: `${exports.WIKI}/Variants#venus-terraforming`,
    showRealtimeVP: `${exports.WIKI}/Variants#show-real-time-vp`,
    fastMode: `${exports.WIKI}/Variants#fast-mode`,
    beginnerCorporation: `${exports.WIKI}/Variants#beginner-corporation`,
    trBoost: `${exports.WIKI}/Variants#tr-boost`,
};
